(function(Drupal, $) {
  Drupal.behaviors.inputSearch = {
    attach: function(context) {
      var headerSearch = $("header .search-with-icon", context);
      headerSearch.addClass("header-search");
      var searchIconInput = $(
        '.search-with-icon:not(".header-search") input[type="text"]',
        context
      );
      if (!searchIconInput.siblings(".search-input-clear").length) {
        searchIconInput.after("<div class='search-input-clear'></div>");
      }
      if (searchIconInput.val()) {
        searchIconInput.addClass("not-empty");
        if (!searchIconInput.siblings(".search-result-clear").length) {
          searchIconInput.after(
            "<a class='search-result-clear'>Clear search results</a>"
          );
        }
      }

      searchIconInput.on("change input", function() {
        var val = $(this).val();
        val ? $(this).addClass("not-empty") : $(this).removeClass("not-empty");
      });

      $(".search-input-clear").on("click", function() {
        $(this)
          .siblings("input")
          .removeClass("not-empty")
          .val("");
      });

      $(".search-result-clear").on("click", function() {
        searchIconInput.val("");
        searchIconInput.removeClass("not-empty");
        $(this)
          .closest("form")
          .find(".js-form-submit")
          .click();
        $(this).remove();
      });

      $("header .search-area").on("click", function() {
        $("header").addClass("search-open");
      });

      $(".header-search .search-base-close").on("click", function() {
        $("header").removeClass("search-open");
      });

      if (
        !$(".header-search input[type=submit]").siblings(".icon-wrapper").length
      ) {
        console.log("here");
        $(".header-search input[type=submit]").after(
          $(".header-search .search-base-icon").html()
        );
      }
    }
  };
})(Drupal, jQuery);
